import React, { useState } from 'react'
import { Element, Notification, Block, Modal, Button, Heading } from 'react-bulma-components'
import { ApiErrorExtracted } from '../../../api'
import { CountBack } from '../../../hooks/use-count-back'

export interface FormErrorProps {
  extracted?: ApiErrorExtracted
  message?: string
  title?: string
  autoClearTimeOut?: number
}

const FormError: React.FunctionComponent<FormErrorProps> = ({
  extracted,
  message,
  title,
  autoClearTimeOut,
}) => {
  const [isDisplayed, setIsDisplayed] = useState(true)

  return (
    <Modal show={isDisplayed} closeOnEsc closeOnBlur onClose={() => setIsDisplayed(false)}>
      <Modal.Content>
        <Block>
          <Notification color="danger" data-testid="form-error">
            <Heading size={5}>{title || extracted?.message || 'Error'}</Heading>
            <Element mb={5}>
              {message ? (
                message
              ) : extracted?.details && extracted.details.length > 0 ? (
                <Element renderAs="ul">
                  {extracted.details.map((detail, index) => (
                    <Element renderAs="li" key={index}>
                      {detail}
                    </Element>
                  ))}
                </Element>
              ) : (
                extracted?.message
              )}
            </Element>
            <p>
              <Button onClick={() => setIsDisplayed(false)} size="small">
                Fermer{' '}
                {autoClearTimeOut !== undefined && (
                  <CountBack seconds={autoClearTimeOut} cb={() => setIsDisplayed(false)} />
                )}
              </Button>
            </p>
          </Notification>
        </Block>
      </Modal.Content>
    </Modal>
  )
}

export default FormError
